const inflight = new Map();

/**
 * Coalesce concurrent identical requests (helps with React Strict Mode double-mount in dev).
 */
export function dedupeRequest(key, fn) {
  if (inflight.has(key)) {
    return inflight.get(key);
  }

  const promise = Promise.resolve()
    .then(fn)
    .finally(() => {
      inflight.delete(key);
    });

  inflight.set(key, promise);
  return promise;
}
